"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showPolicyPage = exports.setLocale = exports.withEpaasApi = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _util = require("../l10n/util.js");

var _async = require("./async.js");

var withEpaasApi = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(f) {
    var _global,
        epaasApiIsReady,
        _args = arguments;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _global = _args.length > 1 && _args[1] !== undefined ? _args[1] : window;

            epaasApiIsReady = function epaasApiIsReady() {
              return _global.epaas && _global.epaas.api.isInitialized();
            };

            _context.next = 4;
            return (0, _async.waitFor)(epaasApiIsReady, 500);

          case 4:
            return _context.abrupt("return", f(_global.epaas.api));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function withEpaasApi(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.withEpaasApi = withEpaasApi;

var setLocale = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(locale) {
    var _global,
        _args2 = arguments;

    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _global = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : window;
            _context2.next = 3;
            return withEpaasApi(function (api) {
              return api.setLocale((0, _util.normalizeLocale)(locale));
            }, _global);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function setLocale(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

exports.setLocale = setLocale;

var showPolicyPage = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(container) {
    var _global,
        policypage,
        _args4 = arguments;

    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _global = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : window;
            _context4.next = 3;
            return withEpaasApi( /*#__PURE__*/function () {
              var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(api) {
                return _regenerator["default"].wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        return _context3.abrupt("return", api.policypage);

                      case 1:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function (_x4) {
                return _ref4.apply(this, arguments);
              };
            }(), _global);

          case 3:
            policypage = _context4.sent;
            policypage.showPolicyPage(container);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function showPolicyPage(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

exports.showPolicyPage = showPolicyPage;